// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"862":"0101d983","988":"c1f080cb"}[chunkId] + ".chunk.css";
};